const STORAGE_KEY = 'agentCode'

function readQueryAgentCode() {
  const fromSearch = new URLSearchParams(window.location.search || '').get('agentCode')
  if (fromSearch) {
    return fromSearch
  }
  const hash = window.location.hash || ''
  const qIndex = hash.indexOf('?')
  if (qIndex >= 0) {
    return new URLSearchParams(hash.slice(qIndex + 1)).get('agentCode')
  }
  return ''
}

export function captureAgentCode(routeQuery) {
  const fromRoute = routeQuery && routeQuery.agentCode
  const code = String(fromRoute || readQueryAgentCode() || '').trim().toUpperCase()
  if (code) {
    localStorage.setItem(STORAGE_KEY, code)
  }
  return getAgentCode()
}

export function getAgentCode() {
  return String(localStorage.getItem(STORAGE_KEY) || '').trim().toUpperCase()
}

export function withAgentCode(payload) {
  const data = payload && typeof payload === 'object' ? { ...payload } : {}
  const code = getAgentCode()
  if (code) {
    data.agentCode = code
  }
  return data
}
